document.documentElement.classList.remove('no-js');

const menuButton = document.querySelector('[data-menu-toggle]');
const menu = document.querySelector('[data-mobile-menu]');
const searchButton = document.querySelector('[data-search-toggle]');
const searchPanel = document.querySelector('[data-search-panel]');
const toast = document.querySelector('[data-zeze-toast]');

function closePanels() {
  menu?.classList.remove('is-open');
  searchPanel?.classList.remove('is-open');
  menuButton?.setAttribute('aria-expanded', 'false');
  searchButton?.setAttribute('aria-expanded', 'false');
}

menuButton?.addEventListener('click', () => {
  const open = !menu?.classList.contains('is-open');
  closePanels();
  if (open) {
    menu?.classList.add('is-open');
    menuButton.setAttribute('aria-expanded', 'true');
  }
});

searchButton?.addEventListener('click', () => {
  const open = !searchPanel?.classList.contains('is-open');
  closePanels();
  if (open) {
    searchPanel?.classList.add('is-open');
    searchButton.setAttribute('aria-expanded', 'true');
    searchPanel?.querySelector('input')?.focus();
  }
});

document.addEventListener('keydown', event => {
  if (event.key === 'Escape') closePanels();
});

// Product forms intentionally use Shopify's native submission and redirect.
// This keeps the cart session authoritative and provides Shopify's built-in
// validation/error handling instead of showing a false AJAX success state.
